import { gql } from "@apollo/client"; import { useLazyQuery } from "@apollo/client/react"; import { Box, Card, InputAdornment, Stack, TextField, Grid } from '@mui/material';
import { useState, useEffect, useMemo, useRef } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Outlet } from 'react-router-dom';
import ErrorDialog from '../../../components/ErrorDialog';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CustomButton } from '../../../components/customButton/CustomButton';

import { GET_INSTITUCIONES_PAGINADAS } from '../../../data/graphQL/queries/usuarios/getInstitucionesByDelegacion';
import { useDebounce } from '../../../hooks/useDebounce';
import { TextInput } from '../../../components/textInput/TextInput';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import Chip from '@mui/material/Chip';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

import './seccionProfesional.scss';
import { normalizeFilterValue } from '../../../helpers/tools';
export default function SeccionProfesional({ roles, delegaciones, profesional, setProfesional, instituciones, setInstituciones }) {

  const [datos, setDatos] = useState('');
  const [dataOriginal, setDataOriginal] = useState('');
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [openInstitucionGrid, setOpenInstitucionGrid] = useState(false);
  const [openProfesionalGrid, setOpenProfesionalGrid] = useState(false);
  const [institucionesAux, setInstitucionesAux] = useState([]);
  const [mensajeError, setMensajeError] = useState("");
  const txtBuscar = useRef(null);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    txtBuscar.current?.focus();

    let rolesProf = [];
    roles.map((rol) => {
      rolesProf.push(rol.id);
    });

    getProfesionales({
      variables: { "roles": rolesProf, "delegaciones": delegaciones }
    });
  }, [roles, delegaciones]);

  const QGetProfesionales = gql`
        query GetProfesionalesDisponiblesRol ($roles: [Int!]!, $delegaciones: [Int!]!) {
            profesionalesDisponiblesRol (roles: $roles, delegaciones: $delegaciones)
                {
                    success,
                    error,
                    valorEsperado {
                        idProfesional,
                        idRol,
                        rol,
                        idTipoProfesional,
                        tipoProfesional,
                        tipoDoc,
                        numeroDoc,
                        apellido,
                        nombre
                    }
                }
        }`;

  const [getProfesionales, { error: errorProfesionales, data: dataProfesionales }] = useLazyQuery(QGetProfesionales, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataProfesionales?.profesionalesDisponiblesRol?.success) return;
    const dataAll = dataProfesionales.profesionalesDisponiblesRol.valorEsperado;
    setDatos(dataAll);
    setDataOriginal(dataAll);
  }, [dataProfesionales]);

  useEffect(() => {
    if (errorProfesionales) {
      setMensajeError("ERRORDB");
    }
  }, [errorProfesionales]);

  const handleClose = () => {
    // cierro el dlg
    setOpenProfesionalGrid(false);
    setOpenInstitucionGrid(false);
  };

  const applyInstituciones = () => {
    setInstituciones(institucionesAux);
    handleClose();
  };

  const handleSearch = () => {
    if (txtBuscar.current.value != "") {
      setDatos(dataOriginal.filter((dataOriginal) => {
        const nombreBuscar = dataOriginal.nombre.toUpperCase();
        const apellidoBuscar = dataOriginal.apellido.toUpperCase();
        const numeroDocumentoBuscar = dataOriginal.numeroDoc.toUpperCase();
        const idProfesionalBuscar = dataOriginal.idProfesional.toString();

        const inputBuscar = normalizeFilterValue(txtBuscar.current.value);
        return (
          idProfesionalBuscar.includes(inputBuscar) ||
          nombreBuscar.includes(inputBuscar) ||
          apellidoBuscar.includes(inputBuscar) ||
          numeroDocumentoBuscar.includes(inputBuscar));

      }
      ));
    } else {
      setDatos(dataOriginal);
    }
  };

  const handleClean = () => {
    txtBuscar.current.value = "";
    handleSearch();
    txtBuscar.current?.focus();
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const initialColumnsProfesionales = [
    { field: 'idProfesional', align: 'center', headerName: 'Id', flex: 0.1, headerAlign: 'center' },
    { field: 'tipoProfesional', align: 'center', headerName: 'Tipo', minWidth: 60, flex: 0.2, headerAlign: 'center' },
    { field: 'apellido', headerName: 'Apellido', minWidth: 80, flex: 0.4, headerAlign: 'center' },
    { field: 'nombre', headerName: 'Nombre', minWidth: 80, flex: 0.4, headerAlign: 'center' },
    { field: 'tipoDoc', align: 'center', headerName: 'Tipo Doc.', flex: 0.1, headerAlign: 'center' },
    { field: 'numeroDoc', align: 'center', headerName: 'Número Documento', minWidth: 60, flex: 0.2, headerAlign: 'center' }];


  // Click sobre fila de la grilla de búsqueda de roles disponibles
  const handleRowClick = (params) => {
    setProfesional(params.row);
    setOpenProfesionalGrid(false);
  };

  const handleDeleteInstitucion = (row) => {
    setInstituciones(instituciones.filter((institucion) => institucion.cod_Institucion !== row.cod_Institucion));
  };

  const initialColumns = [
    { field: 'nombre', headerName: 'Nombre', flex: 0.4 },
    { field: 'domicilio', headerName: 'Domicilio', align: 'center', headerAlign: 'center' }];

  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);
  const columnsProfesionales = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsProfesionales), []);
  const [
    institucionRows,
    handleChangePaginationStatus,
    paginationStatus,
    totalCount,
    selectedFilter,
    setSelectedFilter,
    filterStatus,
    setFilterStatus,
    orderBy,
    setOrderBy,
    institucionesLoading] =
    useGetAllInstituciones(delegaciones);

  // Memoizar el sortModel para evitar pasar una nueva referencia en cada render
  const memoSortModel = useMemo(() =>
    orderBy?.fieldName ? [{ field: orderBy.fieldName, sort: orderBy.order?.toLowerCase() }] : [],
    [orderBy?.fieldName, orderBy?.order]);

  const handleRowClickInstitucion = (newRowSelectionModel) => {
    const normalize = (id) => String(id);
    const currentPageIds = institucionRows.map((r) => normalize(r.cod_Institucion));
    const newPageSelection = new Set(newRowSelectionModel.map(normalize));
    const prevSet = new Set(institucionesAux.map((r) => normalize(r.cod_Institucion)));
    currentPageIds.forEach((id) => prevSet.delete(id));
    newPageSelection.forEach((id) => prevSet.add(id));

    const updatedSelection = [
      // Mantenemos los seleccionados de otras páginas
      ...institucionesAux.filter((inst) => !currentPageIds.includes(normalize(inst.cod_Institucion))),
      // Agregamos los de la página actual que están seleccionados
      ...institucionRows.filter((inst) => newPageSelection.has(normalize(inst.cod_Institucion)))];


    setInstitucionesAux(updatedSelection);
  };

  const handleOpenModalInstituciones = () => {
    setInstitucionesAux(instituciones);
    setOpenInstitucionGrid(true);
  };

  return (
    <>
      <div style={{ display: 'flex', width: '100%', height: '200px' }}>
        <Grid container direction="row" spacing={2} sx={{ width: '100%' }}>
          <Grid size={{ xs: 12, md: 3.5 }}>
            <Card className='paciente-info' elevation={0} sx={{ paddingTop: '8px', paddingBottom: '15px' }}>
              <Grid size={{ xs: 12 }} className='paciente-select-container'>
                <strong>Seleccionar Profesional e Instituciones</strong>
              </Grid>
              <Grid size={{ xs: 12, md: 12 }} sx={{ boxSizing: 'border-box', paddingLeft: '10px', paddingRight: '10px' }}>
                <CustomButton size={"small"} variant="outlined" fullWidth={true} onClick={() => setOpenProfesionalGrid(true)}>Buscador de profesional</CustomButton>
              </Grid>
              <Grid size={{ xs: 12, md: 12 }} sx={{ boxSizing: 'border-box', paddingLeft: '10px', paddingRight: '10px', paddingTop: '10px' }}>
                <CustomButton size={"small"} variant="outlined" fullWidth={true} onClick={handleOpenModalInstituciones}>Buscador de instituciones</CustomButton>
              </Grid>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 8.5 }}>
            <Card className='paciente-info' elevation={0}>
              <h4>Profesional seleccionado</h4>
              <Grid container direction="row" spacing={2}>
                {profesional != "" && profesional != null && profesional.idProfesional > 0 &&
                  <>
                    <Grid size={{ xs: 8, md: 12 }} className='paciente-info-container'>
                      <div className='paciente-info-content'>
                        <strong>ID</strong>
                        {profesional.idProfesional}
                      </div>
                      <div className='paciente-info-content'>
                        <strong>Nombre</strong>
                        {profesional.apellido + ' '}
                        {profesional.nombre}
                      </div>
                      <div className='paciente-info-content'>
                        <strong>Documento</strong>
                        {profesional.tipoDoc} {profesional.numeroDoc}
                      </div>
                      <div className='paciente-info-content'>
                        <DeleteOutlineIcon sx={{ cursor: 'pointer', color: '#818181', width: '20px' }} onClick={() => setProfesional("")} />
                      </div>
                    </Grid>
                  </>
                }
                {instituciones.length > 0 &&
                  <>
                    <Grid size={{ xs: 12 }}>
                      <div className='paciente-info-content'>
                        <strong>Instituciones</strong>
                        <div className='paciente-info-instituciones'>
                          {instituciones.map((institucion, index) => <Chip key={institucion + index} label={institucion.nombre} onDelete={() => handleDeleteInstitucion(institucion)} />)}
                        </div>
                      </div>
                    </Grid>
                  </>
                }
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </div>
      <br />

      <CustomDialog
        maxWidth={'lg'}
        open={openInstitucionGrid}
        onBackdropClick={handleClose}
        className='dialog-container'
        onCancel={handleClose}
        onAccept={applyInstituciones}
        title={'Selecciona las instituciones para el profesional'}
        cancelText='Cerrar'
        acceptText='Aplicar'>

        <div style={{ display: 'flex', width: '100%', minWidth: 800 }}>
          <Grid container direction="row" spacing={2} sx={{ width: '98%' }}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextInput
                onChange={(e) => setFilterStatus(e.target.value)}
                value={filterStatus}
                onClearButtonClick={() => setFilterStatus('')}
                placeholder="Filtrar instituciones"
                searchIcon
                style={{ marginBottom: 20 }} />

            </Grid>
          </Grid>
        </div>
        <DataGridGenerico
          hideFooterPagination={false}
          toolbar={false}
          columns={columns}
          rows={institucionRows.map((ins) => ({
            ...ins,
            id: ins.cod_Institucion
          }))}
          onPageChange={(page) => {
            handleChangePaginationStatus((prev) => ({
              ...prev,
              page: page
            }));
          }}
          onPageSizeChange={(pageSize) => {
            handleChangePaginationStatus((prev) => ({
              ...prev,
              pageSize: pageSize,
              page: 0
            }));
          }}
          pageSize={paginationStatus.pageSize}
          totalCount={totalCount}
          currentPage={paginationStatus.page}
          checkboxSelection
          onRowSelectionModelChange={handleRowClickInstitucion}
          keepNonExistentRowsSelected
          rowSelectionModel={institucionesAux.map((inst) => inst.cod_Institucion)}
          loading={institucionesLoading}
          onSortModelChange={(model) => setOrderBy({ fieldName: model[0]?.field, order: model[0]?.sort?.toLowerCase() })}
          sortModel={memoSortModel} />


      </CustomDialog>

      <CustomDialog
        maxWidth="md"
        width="md"
        open={openProfesionalGrid}
        title={'Selecciona profesional'}
        onCancel={handleClose}>

        <div style={{ minWidth: 800 }}>
          <Stack direction="row" spacing={100} alignItems="center">
            <Box className='botonera-superior-left-search'>
              <TextField
                className="input-350"
                label="Filtrar profesional"
                name="txtBuscar"
                size="small"
                style={{ marginBottom: 20 }}
                type="text"
                variant="outlined"
                inputRef={txtBuscar}
                onKeyUp={handleSearch}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <SearchIcon
                        onClick={handleSearch}
                        sx={{ cursor: 'pointer' }} />

                      <ClearIcon
                        onClick={handleClean}
                        sx={{ cursor: 'pointer' }} />

                    </InputAdornment>

                }} />

            </Box>
          </Stack>
          <DataGridGenerico
            columns={columnsProfesionales}
            onRowClick={handleRowClick}
            rows={datos}
            toolbar={false} />

        </div>
      </CustomDialog>

      <br />
      <Outlet />

      <ErrorDialog
        id="dlg-error-profesional"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />


    </>);


}

const useGetAllInstituciones = (delegaciones) => {
  const [institucionesData, setInstitucionesData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(0);
  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 10,
    page: 0
  });
  const [filterStatus, setFilterStatus] = useState('');
  const [orderBy, setOrderBy] = useState({
    fieldName: 'nombre'
  });
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getAllInstituciones, { data: dataInstituciones, loading: institucionesLoading }] = useLazyQuery(GET_INSTITUCIONES_PAGINADAS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!dataInstituciones) return;
    setInstitucionesData(dataInstituciones);
  }, [dataInstituciones]);

  useEffect(() => {
    getAllInstituciones({
      variables: {
        skip: paginationStatus.page * paginationStatus.pageSize,
        take: paginationStatus.pageSize,
        where: {
          or: [
            { domicilio: { contains: debouncedFilterValue?.trim() } },
            { nombre: { contains: debouncedFilterValue?.trim() } },
            { cod_Institucion: { contains: debouncedFilterValue?.trim() } }],

          and: [
            selectedFilter < 2 ? { activo: { eq: !Boolean(selectedFilter) } } : {},
            { institucionDelegacion: { some: { idDelegacion: { in: delegaciones } } } }]

        },
        order: [{
          [orderBy?.fieldName]: orderBy?.order?.toUpperCase()
        }]
      }
    });
  }, [paginationStatus, selectedFilter, debouncedFilterValue, orderBy]);

  return [
    institucionesData.allInstitucionesByDelegacion?.items || [],
    setPaginationStatus,
    paginationStatus,
    institucionesData?.allInstitucionesByDelegacion?.totalCount,
    selectedFilter,
    setSelectedFilter,
    filterStatus,
    setFilterStatus,
    orderBy,
    setOrderBy,
    institucionesLoading];

};